module.exports = "<div class=\"program-list-container\">\r\n    <div class=\"program-container\">\r\n        <app-skillsets *ngFor=\"let skillset of skillsets | orderByField:'name'\" [skillset]=\"skillset\"></app-skillsets>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/skillset-list/skillset-list.component.html
// module id = ../../../../../src/app/collateralskillsets/skillset-list/skillset-list.component.html
// module chunks = main